const headerHeight = (header: HTMLElement) => {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return header.getBoundingClientRect().height / rootFontSize;
};

export const stickyDebounce = (fn: (...args: unknown[]) => void, delay: number = 100): (...args: unknown[]) => void => {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: unknown[]): void => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

export const updateStickyOffsets = (): void => {
  const updates: Array<{ el: HTMLElement; top: number }> = [];

  document.querySelectorAll<HTMLElement>('.rs-TableItem-header').forEach((tableHeader) => {
    const element = tableHeader.closest<HTMLElement>('.card');
    const elementHeader = element?.querySelector<HTMLElement>('.card-header');
    if (!elementHeader) {
      return;
    }

    elementHeader.classList.add('sticky', 'bg-white');

    updates.push({ el: tableHeader, top: headerHeight(elementHeader) });
  });

  updates.forEach(({ el, top }) => {
    el.style.top = `${top}rem`;
  });
};

const observedHeaders = new WeakSet<HTMLElement>();

export const observeStickyHeaders = (): void => {
  document.querySelectorAll<HTMLElement>('.card-header.sticky').forEach((header) => {
    if (observedHeaders.has(header)) {
      return;
    }

    if (!header.classList.contains('pt-0')) {
      return;
    }

    observedHeaders.add(header);

    const waypoint = document.createElement('div');
    waypoint.className = 'sticky-waypoint';
    header.parentElement?.insertBefore(waypoint, header);

    const tableHeader = header.parentElement?.querySelector<HTMLElement>('.rs-TableItem-header');

    const offset = header.getBoundingClientRect().height;

    const observer = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle('is-stuck', !entry.isIntersecting);
        if (!tableHeader) {
          return;
        }
        tableHeader.style.top = entry.isIntersecting
          ? `${headerHeight(header)}rem`
          : `${headerHeight(header) + 1}rem`;
      },
      { threshold: 0, rootMargin: `-${offset}px 0px 0px 0px` },
    );

    observer.observe(waypoint);
  });
};
